/**
 * @generated SignedSource<<a09c63bfe5040207b65a908dd0286347>>
 * @relayHash 4080d0348429819fb6dfee205f8546af
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b6e5c3406f3aa71a5cc466412df75b93545372ce9a907236748b6d9be75b83a7

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiVersionDetailsQuery } from './uiVersionDetailsQuery.graphql';

const node: PreloadableConcreteRequest<uiVersionDetailsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b6e5c3406f3aa71a5cc466412df75b93545372ce9a907236748b6d9be75b83a7",
    "metadata": {},
    "name": "uiVersionDetailsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
